import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Issue } from "../../../../../shared/models/issue.model";
import { ModalComponent } from "../../../../../shared/components/index";
import { Tool } from '@app/tool/model/tool.model';

@Component({
    selector: 'app-issue-modal',
    templateUrl: './issue-modal.component.html',
    styleUrls: ['./issue-modal.component.scss']
})
export class IssueModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() hasCancel = true;
    @Input() hasApprove = false;
    @Input() hasReject = false;
    @Input() isLoading: boolean;

    @Output() promoteToTicket = new EventEmitter<any>();
    @Output() reject = new EventEmitter<any>();

    issueForm: UntypedFormGroup;
    issue = new Issue();
    showValidations = false;
    multipleTools = false;
    selectedTool: Tool;

    constructor() {
    }

    open(issue = new Issue(), selectedToolId: number, multipleTools: boolean) {
        this.multipleTools = multipleTools && issue.tools && issue.tools.length > 1;
        this.selectedTool = issue.tools.filter(x => x.id === selectedToolId)[0];
        this.reset();
        this.loadFormValue(issue);
        this.modal.open();
    }

    ngOnInit() {
        this.issueForm = new UntypedFormGroup({
            toolUid: new UntypedFormControl('', [<any>Validators.required]),
            reasonId: new UntypedFormControl('', [<any>Validators.required]),
            description: new UntypedFormControl('', [<any>Validators.required]),
            isReplacementOrdered: new UntypedFormControl(false, [<any>Validators.required]),
            status: new UntypedFormControl(''),
            createdBy: new UntypedFormControl(''),
            createdAt: new UntypedFormControl('')
        });
    }

    get isViewMode() {
        return !!this.issue.id;
    }

    private reset() {
        this.showValidations = false;
        this.issueForm.reset();
    }

    private loadFormValue(issue) {
        this.issue = issue;
        this.issueForm.setValue({
            toolUid: issue.tools[0].toolUid,
            reasonId: issue.reason.id,
            description: issue.description,
            createdAt: issue.createdAt,
            createdBy: issue.user.fullName,
            status: issue.status,
            isReplacementOrdered: issue.isReplacementOrdered
        });
    }

    close() {
        this.modal.close();
    }

    emitPromote(forAll: boolean = true) {
        this.promoteToTicket.emit(this.constructIssueTools(forAll));
    }

    emitReject(forAll: boolean = true) {
        this.reject.emit(this.constructIssueTools(forAll));
    }

    isOpen() {
        return this.modal.isOpen();
    }

    private constructIssueTools(forAll: boolean) {
        const issueDetails = new Issue({
            id: this.issue.id,
            tools: this.issue.tools,
            reason: this.issue.reason,
            description: this.issue.description
        })
        if (!forAll) {
            issueDetails.tools = [this.selectedTool];
        }
        return issueDetails;
    }
}
